export default {
  /* Fail Log Mutations. start * */
  /* 초기화 * */
  INIT_DATA(state, payload) {
    if (payload == 'ALL') {
      state.userProjectList = [];
      state.projectDetail = [];
      state.projectEnvs = [];
      state.envTab = [];
      state.resourceUserList = [];
    }
  },
  /* 실패 로그 목록 변이 * */
  SET_FAIL_LOG_LIST(state, payload) {
    state.failLogList = payload.rows;
    state.currentPage = payload.currentPage;
    state.pageSize = payload.pageSize;
    state.pageUnit = payload.pageUnit;
    state.records = payload.records;
  },
  /* Fail Log Mutations. end  * */
};



// WEBPACK FOOTER //
// ./src/vuex/rem/log/logMutations.js